import { Modal } from 'antd';
import React from 'react';
import { useTheme } from 'src/styles/theme';

// import classes from './style/AppCenterModal.module.css';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IAppCenterModalProps {
  visible?: boolean;
  children?: React.ReactNode;
  closeModal?: () => void;
  title?: React.ReactNode;
}

const AppCenterModal: React.FunctionComponent<IAppCenterModalProps> = (
  props
) => {
  // TOOLS
  const theme = useTheme();
  // const { t } = useTranslation();

  // PROPS
  const { children, closeModal, visible, title } = props;

  // STATE

  // SELECTORS

  // VIEW
  return (
    <Modal
      open={visible}
      onCancel={closeModal}
      cancelButtonProps={{ style: { display: 'none' } }}
      okButtonProps={{ style: { display: 'none' } }}
      styles={{
        content: {
          borderTop: `5px solid ${theme.colors.primary}`,
          width: 800,
          padding: 0
        }
      }}
      title={title}
      mask={true}
      footer={false}
    >
      {children}
    </Modal>
  );
};

export default AppCenterModal;
